import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      setFormMessage('Спасибо за подписку!');
      form.reset();
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d958m0441f1vs39a6uh0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('Спасибо за подписку!');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;
        setFormStatus('error');
        setFormMessage(typeof serverMsg === 'string' ? serverMsg : 'Произошла ошибка. Попробуйте позже.');
      }
    } catch {
      setFormStatus('error');
      setFormMessage('Произошла ошибка. Попробуйте позже.');
    }
  };
  return (
    <footer className="bg-foreground-950 text-white rounded-t-[40px] mx-4 md:mx-10 mt-8">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <h3 className="text-2xl font-heading font-light tracking-wide">YOYBUY Sheet</h3>
            <p className="mt-3 text-sm text-foreground-300 font-light leading-relaxed max-w-[320px]">
              Ваш надёжный гид в мире шоппинга из Китая. Подписывайтесь на новости и получайте лучшие предложения первыми.
            </p>

            <form
              data-readdy-form
              id="newsletter-form"
              onSubmit={handleSubmit}
              className="mt-6 flex flex-col sm:flex-row gap-3 max-w-[380px]"
            >
              <input
                type="email"
                name="email"
                placeholder="Ваш email"
                required
                className="flex-1 h-11 px-4 bg-transparent border-b border-foreground-600 text-white text-sm placeholder:text-foreground-500 outline-none focus:border-accent-400 transition-colors"
              />
              <input
                type="text"
                name="website_alt"
                className="honeypot-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                className="h-11 px-6 rounded-full bg-white text-foreground-950 text-sm font-medium hover:bg-accent-50 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                Подписаться
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
            {formStatus !== 'idle' && (
              <p className={`mt-3 text-xs ${formStatus === 'success' ? 'text-accent-400' : 'text-primary-400'}`}>
                {formMessage}
              </p>
            )}
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-label font-semibold uppercase tracking-wider text-foreground-300">Навигация</h4>
            <nav className="mt-4 flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-400 hover:text-white underline transition-colors cursor-pointer">
                Главная
              </Link>
              <Link to="/article/yoybuy-spreadsheet-guide" className="text-sm text-foreground-400 hover:text-white underline transition-colors cursor-pointer">
                YOYBUY Spreadsheet Гайд
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white underline transition-colors cursor-pointer">
                Kaspreadsheet
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white underline transition-colors cursor-pointer">
                Buy It Now
              </a>
            </nav>
          </div>

          <div className="md:col-span-5">
            <h4 className="text-sm font-label font-semibold uppercase tracking-wider text-foreground-300">Контакты</h4>
            <div className="mt-4 space-y-2">
              <p className="text-sm text-foreground-400">Email: support@yoybuy.beauty</p>
              <p className="text-sm text-foreground-400">Telegram: @yoybuy_support</p>
            </div>
            <h4 className="text-sm font-label font-semibold uppercase tracking-wider text-foreground-300 mt-6">Адрес</h4>
            <p className="mt-2 text-sm text-foreground-400 leading-relaxed">
              г. Москва, ул. Примерная, д. 1<br />
              Россия, 101000
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <span className="text-sm text-foreground-500">Instagram</span>
            <span className="text-sm text-foreground-500">Telegram</span>
          </div>
          <p className="text-xs text-foreground-500 font-light">
            &copy; 2026 YOYBUY Beauty. Все права защищены.
          </p>
          <div className="flex items-center gap-5">
            <span className="text-xs text-foreground-500">Privacy Policy</span>
            <span className="text-xs text-foreground-500">Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
}